/* eslint-disable max-len */
import STRIcon from '../../../../../assets/environmental.png';
import METIcon from '../../../../../assets/general.png';
import GOVIcon from '../../../../../assets/governance.png';
import RISKIcon from '../../../../../assets/social.png';
import {pillers} from '../../../../../components/Forms/Constants/TCFD/AutoMobile/autoMobileQuestions';
import {getTcfdUrl} from '../utils/utils';

import {
  GovernanceTabQuestions,
  MetricsTargetsTabQuestions,
  RiskManagementTabQuestions,
  StrategyTabQuestions
} from './autoMobileTabs';

export const autoMobileGovernance = {
  pillarId: pillers.autoMobileGovernance,
  header: {
    imageUrl: GOVIcon,
    title: 'Governance',
    description: `Clarifies board- and management-level accountability for 
climate matters, the foundation for all further action.`,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getTcfdUrl(pillers.autoMobileGovernance,'5'),
  tabs: [
    {
      id: 'tab_governance',
      title: 'Governance',
      questions: GovernanceTabQuestions
    }
  ]
};

export const autoMobileStrategy = {
  pillarId: pillers.autoMobileStrategy,
  header: {
    imageUrl: STRIcon,
    title: 'Strategy',
    description:
      'Tests business resilience under plausible climate scenarios to inform long-term planning.',
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getTcfdUrl(pillers.autoMobileStrategy,'5'),
  tabs: [
    {
      id: 'tab_strategy',
      title: 'Strategy',
      questions: StrategyTabQuestions
    }
  ]
};

export const autoMobileRiskManagement = {
  pillarId: pillers.autoMobileRiskManagement,
  header: {
    imageUrl: RISKIcon,
    title: 'Risk Management',
    description:
      'Integrates climate-related risks and opportunities into the enterprise risk framework to prevent surprises.',
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getTcfdUrl(pillers.autoMobileRiskManagement,'5'),
  tabs: [
    {
      id: 'tab_risk_management',
      title: 'Risk Management',
      questions: RiskManagementTabQuestions
    }
  ]
};

export const autoMobileMetricsTargets = {
  pillarId: pillers.autoMobileMetricsTargets,
  header: {
    imageUrl: METIcon,
    title: 'Metrics & Targets',
    description:
      'Establishes quantifiable indicators and deadlines to track and demonstrate progress with credibility.',
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getTcfdUrl(pillers.autoMobileMetricsTargets,'5'),
  tabs: [
    {
      id: 'tab_metrics_targets',
      title: 'Metrics & Targets',
      questions: MetricsTargetsTabQuestions
    }
  ]
};
